<template>
  <div class="dataEdit">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="dataEdit.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="dataEdit"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="维护日期">
          <el-date-picker
              v-model="dataEdit.maintenanceDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="维护类型">
          <el-select v-model="dataEdit.maintenanceType" clearable placeholder="请选择">
            <el-option
                v-for="item in maintenanceTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
        <!--        <el-form-item v-if="dataEdit.maintenanceType === 2 || dataEdit.maintenanceType === 3" label="设备编号">-->
        <!--          <el-input v-model="dataEdit.equipmentCode" placeholder="请输入" readonly>-->
        <!--            <el-button-->
        <!--                slot="append"-->
        <!--                icon="el-icon-search"-->
        <!--                @click="$refs.selectEquipment.open()">-->
        <!--              选择-->
        <!--            </el-button>-->
        <!--          </el-input>-->
        <!--          <equipment-select ref="selectEquipment" @select="selectEquipment"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="备注">
          <el-input v-model="dataEdit.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  // import EquipmentSelect from "@/views/em/Equipment/EquipmentSelect";
  export default {
    name:"DataEdit",
    components: {},
    data() {
      return {
        constant,
        maintenanceTypes: constant.toSelect(constant.maintenanceType),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        dataEdit: {
          pkid:"",
          maintenanceDate: "",
          maintenanceType: 1,
          // equipmentID: "",
          // equipmentCode: "",
          note: "",
        },
        ruleValidate: {
          maintenanceDate: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dataEdit.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `eMDateMaintenances/${this.dataEdit.pkid}`)
          .then(resp => {
            this.dataEdit = resp;
            console.log(this.dataEdit);
          });
      },
      selectEquipment(row) {
        this.dataEdit.equipmentId = row.pkid;
        this.dataEdit.equipmentCode = row.no;
      },
      // getNote() {
      //   this.$http
      //     .get("basic", "districts/selectNo")
      //     .then(resp => {
      //       this.dataEdit.districtNO = resp;
      //     });
      // },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "eMDateMaintenances", this.dataEdit)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .dataEdit{
    .el-date-editor.el-input.el-input--mini.el-input--prefix.el-input--suffix.el-date-editor--datetime{
      width: 100%!important;
    }
  }
</style>
